import type { LeadFlowQuestion } from "./types";

import { POSTAL_CODE_FIELD_NAME } from "./lead-form-field-names";

const LEAD_FLOW_CONTACT_QUESTION_TYPE = "leadFlowContactQuestion";

const LEAD_FLOW_SINGLE_FIELD_QUESTION_TYPES: Record<string, string> = {
  leadFlowCareForQuestion: "careFor",
  leadFlowCareTypeQuestion: "careType",
  leadFlowPostalCodeQuestion: POSTAL_CODE_FIELD_NAME,
  leadFlowUrgencyQuestion: "urgency",
};

/**
 * Lead flow questions are typed, so the contract fields a question collects
 * follow from its `_type` rather than an authored field name. A contact
 * question collects each contact field it lists. Non-question items collect
 * nothing.
 */
function getLeadFlowQuestionFieldNames(
  question: LeadFlowQuestion | null | undefined,
): string[] {
  const questionType = question?._type;
  if (!questionType) {
    return [];
  }

  if (questionType === LEAD_FLOW_CONTACT_QUESTION_TYPE) {
    return (question.fields ?? []).flatMap((entry) =>
      entry?.field ? [entry.field] : [],
    );
  }

  const fieldName = LEAD_FLOW_SINGLE_FIELD_QUESTION_TYPES[questionType];

  return fieldName ? [fieldName] : [];
}

export { getLeadFlowQuestionFieldNames };
